import { type CertificateValidationType, CertificateValidationTypes, SystemNotificationType } from "./types";

export const certificateValidationTypes: CertificateValidationType[] = [
  { name: "None", type: CertificateValidationTypes.None },
  { name: "Selfsigned Certificate", type: CertificateValidationTypes.SelfSigned },
  { name: "Full", type: CertificateValidationTypes.Full },
];

export const systemNotificationSettingTooltips = {
  [SystemNotificationType.Engagement]:
    "Control whether or not users receive our recommended Weekly User Digest. (Note: User Engagement Pack must be enabled to activate this feature.)",
  [SystemNotificationType.ManagerDigest]:
    "Control whether or not managers receive our recommended Manager Digest email. (Note: User Engagement Pack must be enabled to activate this feature.)",
};

export const threatDefenseSettingTooltip =
  "This method employs Microsoft Graph to place simulated phishing emails directly in a user's inbox. This is important for ensuring better delivery rates and more effective phishing simulations.";

export const customSendSettingTooltip =
  "BrainStorm is configured to email your end users. Choose this option to configure your own send method.";

export const threatDefenseDirectSendTooltip =
  "This method employs a standard SMTP mail server to send simulated phishing emails.";
